import React, { useState, useEffect } from "react";
import useDisplay from "../../../hooks/useDisplay";

function MainBorderBtn(props) {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [hover, setHover] = useState(false);

  return (
    <>
      <div
        onClick={props.disabled ? null : props.onClick}
        onMouseEnter={() => setHover(true)} // 마우스엔터(호버)시 키값이 저장된다
        onMouseLeave={() => setHover(false)} // 마우스리브 시에는 키값이 지워진다
        style={{
          width: "100%",
          cursor: "pointer",
          height: 46,
          borderRadius: 15,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          background: "#fff",
          color: props.disabled ? "#DBDDE0" : hover ? "#000075" : "#5050FF",
          border: ` 1px solid ${
            props.disabled ? "#DBDDE0" : hover ? "#8585FF" : "#5050FF"
          }`,

          ...props.style,
        }}
      >
        {props.children}
      </div>
    </>
  );
}

export default MainBorderBtn;
